module.exports = __webpack_public_path__ + "img/limited-time-claim-btn.889d350e.png";